import React, { Fragment, Component } from 'react';
import capitalize from 'lodash/capitalize';
import type { Node } from 'react';
import { FormGroup, Label } from 'reactstrap';

import { sortBookingsToOldest } from './utils';

type Props = {
  children: Node,
};

export default class SortAndFilter extends Component<Props> {
  styles = {
    show: { display: '' },
    hide: { display: 'none' },
  };

  state = { sortType: 'latest', filterBy: 'pending' };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  sortBookings = bookings => {
    const { sortType } = this.state;
    const bookingsByOldest = sortBookingsToOldest(bookings);

    if (sortType === 'oldest') return bookingsByOldest;
    if (sortType === 'latest') return bookingsByOldest.reverse();
  };

  showOrHide = statusType => {
    const { filterBy } = this.state;
    const { show, hide } = this.styles;

    if (filterBy === 'all') return show;

    return filterBy === statusType.toLowerCase() ? show : hide;
  };

  render() {
    const { sortBookings, showOrHide, handleChange, state, props } = this;
    const { sortType, filterBy } = state;

    return (
      <Fragment>
        <SelectWithOptions
          name="sortType"
          optionsArr={['oldest', 'latest']}
          labelText="Sort(BookingDate)"
          selectedValue={sortType}
          handleChange={handleChange}
        />

        <SelectWithOptions
          name="filterBy"
          optionsArr={['all', 'pending', 'rejected', 'accepted']}
          labelText="Filter"
          selectedValue={filterBy}
          handleChange={handleChange}
        />

        {props.children({
          sortBookings,
          showOrHide,
        })}
      </Fragment>
    );
  }
}

const SelectWithOptions = ({
  optionsArr,
  labelText,
  handleChange,
  selectedValue,
  name,
}) => (
  <FormGroup className="col-md-6 col-12">
    <Label for="searchTerm">{labelText}</Label>
    <div className="region-select">
      <select name={name} onChange={handleChange}>
        {optionsArr.map(option => (
          <option value={option} selected={option === selectedValue} key={option}>
            {capitalize(option)}
          </option>
        ))}
      </select>
    </div>
  </FormGroup>
);



// WEBPACK FOOTER //
// ./src/screens/BookingsDashboard/SortAndFilter.jsx